module.exports = __webpack_public_path__ + "assets/img/1_big.5c3e634d.png";